import React from "react";
import PropTypes from "prop-types";

const VideoCardText = ({
  title = "A Journey from Adversity to Entrepreneurship.",
  description = "",
  className = ""
}) => {
  return (
    <div className={`card__text--container ${className}`}>
      <div className="card__title">{title}</div>
      <div className="card__description">{description}</div>
    </div>
  );
};

VideoCardText.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string
};

export default VideoCardText;
